import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export interface CustomerOrderTemplateOption {
  id: string;
  name: string;
  default_key: string | null;
}

/**
 * Template documento degli ordini cliente dell'organizzazione (quote_templates
 * con document_kind 'customer_order', non archiviati): servono per scegliere
 * con quale template scaricare o inviare il PDF di un ordine.
 * Con `enabled` false non fa query. `loaded` diventa true a lettura finita
 * (anche se fallisce, con elenco vuoto).
 */
export function useCustomerOrderTemplates(
  organizationId: string | null | undefined,
  enabled: boolean,
  // Stesso elenco per gli ordini fornitore (document_kind 'supplier_order')
  documentKind: 'customer_order' | 'supplier_order' = 'customer_order',
) {
  const [templates, setTemplates] = useState<CustomerOrderTemplateOption[]>([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setTemplates([]);
    setLoaded(false);
    if (!enabled || !organizationId) return;
    let active = true;
    void supabase
      .from('quote_templates')
      .select('id,name,default_key')
      .eq('organization_id', organizationId)
      .eq('document_kind', documentKind)
      .is('archived_at', null)
      .order('name')
      .then(({ data, error }) => {
        if (error) console.warn('Template ordine non letti', error);
        if (!active) return;
        setTemplates((data || []) as CustomerOrderTemplateOption[]);
        setLoaded(true);
      });
    return () => { active = false; };
  }, [organizationId, enabled, documentKind]);
  return { templates, loaded };
}
